import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PoundSterling, ShoppingCart, Package, Users, TrendingUp, AlertTriangle } from "lucide-react";
import { api, gbp } from "@/lib/api";

const Stat = ({ icon: Icon, label, value, testid }) => (
  <div className="bg-white border border-brand-border rounded-sm p-6" data-testid={testid}>
    <div className="flex items-center justify-between mb-2"><span className="text-xs uppercase tracking-luxe text-muted-foreground">{label}</span><Icon className="w-4 h-4 text-brand-pink" /></div>
    <p className="font-serif-display text-3xl">{value}</p>
  </div>
);

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then((r) => setD(r.data)); }, []);
  if (!d) return <p className="text-muted-foreground">Loading…</p>;
  return (
    <div>
      <h1 className="font-serif-display text-4xl mb-8">Dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
        <Stat icon={PoundSterling} label="Revenue" value={gbp(d.revenue)} testid="stat-revenue" />
        <Stat icon={ShoppingCart} label="Paid orders" value={d.orders} testid="stat-orders" />
        <Stat icon={Package} label="Products" value={d.products} testid="stat-products" />
        <Stat icon={Users} label="Customers" value={d.customers} testid="stat-customers" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white border border-brand-border rounded-sm p-6">
          <h3 className="font-serif-display text-xl mb-4 flex items-center gap-2"><TrendingUp className="w-5 h-5 text-brand-pink" /> Bestsellers</h3>
          {d.bestsellers.length === 0 ? <p className="text-sm text-muted-foreground">No sales yet.</p> : (
            <div className="space-y-3">{d.bestsellers.map((b, i) => (<div key={i} className="flex justify-between text-sm"><span>{b.title}</span><span className="text-muted-foreground">{b.qty} sold · {gbp(b.revenue)}</span></div>))}</div>
          )}
        </div>
        <div className="bg-white border border-brand-border rounded-sm p-6">
          <h3 className="font-serif-display text-xl mb-4 flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-brand-pink" /> Low stock</h3>
          {d.low_stock.length === 0 ? <p className="text-sm text-muted-foreground">All stock levels healthy.</p> : (
            <div className="space-y-3">{d.low_stock.map((p) => (<div key={p.id} className="flex justify-between text-sm"><Link to="/admin/products" className="underline">{p.title}</Link><span className={p.stock <= 0 ? "text-destructive" : "text-muted-foreground"}>{p.stock} left</span></div>))}</div>
          )}
        </div>
      </div>
      <div className="bg-white border border-brand-border rounded-sm p-6 mt-6">
        <h3 className="font-serif-display text-xl mb-4">Recent orders</h3>
        {d.recent_orders.length === 0 ? <p className="text-sm text-muted-foreground">No orders yet.</p> : (
          <div className="space-y-2">{d.recent_orders.map((o) => (<div key={o.id} className="flex justify-between text-sm border-b border-brand-border pb-2"><span>{o.order_number} · {o.customer?.name}</span><span>{gbp(o.total)}</span></div>))}</div>
        )}
      </div>
    </div>
  );
}
